import React from 'react';
import './Badge.css';

/**
 * Reusable Badge Component
 *
 * @param {string} variant - 'default' | 'primary' | 'success' | 'error' | 'warning' | 'info'
 * @param {string} size - 'sm' | 'md' | 'lg'
 * @param {boolean} dot - Show as dot indicator
 * @param {string} className - Additional CSS classes
 */
function Badge({
  children,
  variant = 'default',
  size = 'md',
  dot = false,
  className = '',
  ...props
}) {
  const classes = [
    'badge',
    `badge-${variant}`,
    `badge-${size}`,
    dot && 'badge-dot',
    className
  ].filter(Boolean).join(' ');

  return (
    <span className={classes} {...props}>
      {children}
    </span>
  );
}

export default Badge;
